export default [
  {
    path: 'custom-homepage',
    name: 'website.custom-homepage',
    component: () => import('@/views/website/themes/homepage/index.vue'),
  },
];
